import { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencil, faSquareMinus, faSquarePlus } from "@fortawesome/free-solid-svg-icons";
import Swal from "sweetalert2";
import api from "../../services/api";
import EditModal from "../ui/EditModal";
import { normalizar } from "../../common/stringNormalizer";

export default function CatalogoTratamientoABM({ endpoint, idField, titulo, nombreCampo }) {
  const [items, setItems] = useState([]);
  const [Nombre, setNombre] = useState("");
  const [Descripcion, setDescripcion] = useState("");
  const [filtroEstado, setFiltroEstado] = useState("activas");
  const [seleccionado, setSeleccionado] = useState(null);

  const cargar = async () => {
    try { setItems((await api.get(endpoint)).data); }
    catch (error) { console.error(error); Swal.fire("Error", "No se pudo cargar el catálogo.", "error"); }
  };
  useEffect(() => { cargar(); }, [endpoint]);

  const guardar = async (event) => {
    event.preventDefault();
    if (items.some((item) => normalizar(item.Nombre) === normalizar(Nombre))) return Swal.fire("Duplicado", "Ya existe un registro con ese nombre.", "warning");
    try {
      await api.post(endpoint, { Nombre, Descripcion });
      setNombre(""); setDescripcion(""); setFiltroEstado("activas"); await cargar();
      Swal.fire({ icon: "success", title: "Registro guardado", timer: 1500, showConfirmButton: false });
    } catch (error) { Swal.fire("Error", error.response?.data?.msg || "No se pudo guardar el registro.", "error"); }
  };

  const editar = async (values) => {
    try {
      await api.put(`${endpoint}/${values[idField]}`, { Nombre: values.Nombre, Descripcion: values.Descripcion });
      setSeleccionado(null); await cargar();
      Swal.fire({ icon: "success", title: "Registro actualizado", timer: 1500, showConfirmButton: false });
    } catch (error) { Swal.fire("Error", error.response?.data?.msg || "No se pudo actualizar el registro.", "error"); }
  };

  const cambiarEstado = async (row) => {
    if (Number(row.Estado) === 1) {
      const respuesta = await Swal.fire({ icon: "warning", title: "¿Desactivar registro?", text: "Si está asignado a una persona, no podrá desactivarse.", showCancelButton: true, confirmButtonText: "Sí, desactivar", cancelButtonText: "Cancelar" });
      if (!respuesta.isConfirmed) return;
    }
    try {
      await api.patch(`${endpoint}/${row[idField]}/estado`); await cargar();
      Swal.fire({ icon: "success", title: Number(row.Estado) === 1 ? "Registro desactivado" : "Registro activado", timer: 1500, showConfirmButton: false });
    } catch (error) { Swal.fire("No permitido", error.response?.data?.msg || "No se pudo cambiar el estado.", error.response?.status === 409 ? "warning" : "error"); }
  };

  const datos = items.filter((item) => filtroEstado === "todas" || Number(item.Estado) === (filtroEstado === "activas" ? 1 : 0));
  const columnas = [
    { name: "Nombre", selector: (row) => row.Nombre, sortable: true, width: "20vw" },
    { name: "Descripción", selector: (row) => row.Descripcion || "Sin descripción", sortable: true, width: "35vw", wrap: true },
    { cell: (row) => <button className="button is-small is-info" title="Editar" onClick={() => setSeleccionado(row)}><FontAwesomeIcon icon={faPencil} /></button>, button: true },
    { cell: (row) => <FontAwesomeIcon icon={Number(row.Estado) === 1 ? faSquarePlus : faSquareMinus} style={{ color: Number(row.Estado) === 1 ? "#37ff00" : "#ff0000", cursor: "pointer" }} size="2xl" onClick={() => cambiarEstado(row)} />, button: true },
  ];

  return <div className="columns mt-5 is-centered"><div>
    <div className="notification is-primary"><strong>{titulo}</strong></div>
    <form onSubmit={guardar}>
      <div className="field"><label className="label required">{nombreCampo}</label><div className="control"><input className="input" value={Nombre} onChange={(e) => setNombre(e.target.value)} placeholder="Nombre" required /></div></div>
      <div className="field"><label className="label">Descripción</label><div className="control"><input className="input" value={Descripcion} onChange={(e) => setDescripcion(e.target.value)} placeholder="Descripción" /></div></div>
      <div className="field mt-3"><button className="button is-success" type="submit">Guardar</button></div>
    </form>
    <div style={{ display: "flex", gap: 10, margin: "1rem 0" }}>{["todas", "activas", "inactivas"].map((estado) => <button key={estado} type="button" className={`button is-small ${filtroEstado === estado ? "is-primary" : "is-light"}`} onClick={() => setFiltroEstado(estado)}>{estado[0].toUpperCase() + estado.slice(1)}</button>)}</div>
    <DataTable pagination paginationComponentOptions={{ rowsPerPageText: "Filas por página", rangeSeparatorText: "de", selectAllRowsItem: true, selectAllRowsItemText: "Todos" }} columns={columnas} data={datos} />
    {seleccionado && <EditModal fields={[{ name: "Nombre", label: nombreCampo, type: "text", required: true }, { name: "Descripcion", label: "Descripción", type: "text" }]} initialValues={seleccionado} onSubmit={editar} title={`Editar ${nombreCampo.toLowerCase()}`} onClose={() => setSeleccionado(null)} />}
  </div></div>;
}
